import * as React from 'react';
import Step, { stepClasses } from '@mui/joy/Step';
import StepIndicator, { stepIndicatorClasses } from '@mui/joy/StepIndicator';
import Stepper from '@mui/joy/Stepper';
import Typography from '@mui/joy/Typography';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';

/**
 * Shows a 3-step “Dotted” stepper for levels:
 *   1) Verdadero y Falso
 *   2) Respuesta Múltiple
 *   3) Preguntas de Examen
 */
function IconStepper({ currentStep }) {
  // Adjust your steps to just 1..3
  const steps = [
    { number: 1, description: 'Verdadero y Falso' },
    { number: 2, description: 'Respuesta Múltiple' },
    { number: 3, description: 'Preguntas de Examen' },
  ];

  // Default to step 1 if not provided
  const activeStep = currentStep ?? 1;

  return (
    <Stepper
      size="sm"
      sx={{
        width: '100%',
        '--StepIndicator-size': '1.5rem',
        '--Step-connectorInset': '3px',
        [`& .${stepIndicatorClasses.root}`]: {
          borderWidth: 2,
        },
        [`& .${stepClasses.root}::after`]: {
          height: 2,
        },
        [`& .${stepClasses.completed}`]: {
          [`& .${stepIndicatorClasses.root}`]: {
            borderColor: 'primary.300',
            color: 'primary.300',
          },
          '&::after': {
            bgcolor: 'primary.300',
          },
        },
        [`& .${stepClasses.active}`]: {
          [`& .${stepIndicatorClasses.root}`]: {
            borderColor: 'currentColor',
          },
        },
        [`& .${stepClasses.disabled} *`]: {
          color: 'neutral.outlinedDisabledColor',
        },
      }}
    >
      {steps.map((step, index) => (
        <Step
          key={index}
          // completed: step is before the current
          completed={index < activeStep - 1}
          // active: step is exactly the current
          active={index === activeStep - 1}
          // disabled: step is beyond the current
          disabled={index >= activeStep}
          orientation="vertical"
          indicator={
            <Tooltip title={step.description} arrow>
              <StepIndicator
                variant={index === activeStep - 1 ? 'solid' : 'outlined'}
                color={index >= activeStep ? 'neutral' : 'primary'}
              >
                <Typography fontSize="0.8rem">{step.number}</Typography>
              </StepIndicator>
            </Tooltip>
          }
        >
          {/* Show text under the indicator only for the active step */}
          {index === activeStep - 1 && (
            <Typography
              sx={{
                display: 'none', // Hide the text description to save space
              }}
            >
              {step.description}
            </Typography>
          )}
        </Step>
      ))}
    </Stepper>
  );
}

IconStepper.propTypes = {
  currentStep: PropTypes.number,
};

IconStepper.defaultProps = {
  currentStep: 1,
};

export default IconStepper;
